export const state = {
  sector: [],
};
